
import vhero from "@/components/shared/VHero.vue";
import Vue from "vue";
import moment from "moment";

export default Vue.extend({
  components: { vhero },
  mounted() {
    this.$http
      .get("Registro", {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
      .then(res => {
        this.data = res.data.registros
        this.esCargado = true
        })
      .catch(() => {this.esCargado = true})
  },
  data() {
    return {
      data: [""],
      esCargado: false
    };
  },
  methods: {
    formatDate(fecha: string) {
      const d = moment(fecha, "MM/DD/YYYY").format("DD/MM/YYYY");
      return d === "Invalid date" ? fecha : d;
    },
    formatTrabajado(fecha: string){
      const horas = fecha[0] == "0" ? fecha.slice(1,2) : fecha.slice(0,2)
      const minutos = fecha[3] == "0" ? fecha.slice(4,5) : fecha.slice(3,5)
      return  horas + "h y " + minutos + "min"
    }
  }
});
